<template>
<div class="workOrder">
  <div class="order-top">
    <div class="iconfont iconzuojiantou jian" @click="goBack"></div>
    <div>我的工单</div>
    <div></div>
  </div>
  <div class="order-tab">
    <van-tabs v-model="formData.workloadStatus" @click="changeTab" style="padding-bottom:45px">
      <van-tab title="待确认" name="1">
        <div class="gongdan" v-if="orderList.length===0">
          <img :src="gongdan" alt="">
        </div>
        <div class="tab-detail" v-for="item in orderList" :key="item.id" @click="toDetailPage(item)">
          <div class="detail-left">
            <div class="basic-title">{{item.platformDetailDTO.taskName}}</div>
            <div class="date-time"><span>{{item.createdAt}} -- </span><span>{{item.endTime}}</span></div>
            <div class="message">
              <div class="posi"><img :src="duigou" alt=""></div>
              <div>{{item.userName}}</div>
              <div class="posi" style="margin-left:16px"><img :src="daiqueren" alt=""></div>
              <div>{{item.companyName}}</div>
            </div>
          </div>
          <div class="detail-right">
            <div class="detail-cont" v-if="item.workloadStatusNew===1">未确认</div>
            <div class="detail-cont" v-if="item.workloadStatusNew===2">拒绝确认</div>
            <div class="detail-cont" v-if="item.workloadStatusNew===3">待结算</div>
            <div class="detail-cont" v-if="item.workloadStatusNew===4">已关闭</div>
            <div class="detail-cont" v-if="item.workloadStatusNew===5">已结算</div>
            <div class="detail-cont" v-if="item.workloadStatusNew===6">不可结算</div>
            <div class="detail-cont" v-if="item.workloadStatusNew===7">待打款</div>
            <div v-if="item.salaryQuantity">服务数量：{{item.salaryQuantity}}</div> 
            <div v-else></div> 
          </div>
        </div>
      </van-tab>
      <van-tab title="待结算" name="2">
        <div class="gongdan" v-if="orderList.length===0">
          <img :src="gongdan" alt="">
        </div>
        <div class="tab-detail" v-for="item in orderList" :key="item.id">
          <div class="detail-left">
            <div class="basic-title">{{item.platformDetailDTO.taskName}}</div>
            <div class="date-time"><span>{{item.createdAt}} -- </span><span>{{item.endTime}}</span></div>
            <div class="message">
              <div class="posi"><img :src="duigou" alt=""></div>
              <div>{{item.userName}}</div>
              <div class="posi" style="margin-left:16px"><img :src="daiqueren" alt=""></div>
              <div>{{item.companyName}}</div>
            </div>
          </div>
          <div class="detail-right">
            <div class="detail-cont" v-if="item.workloadStatusNew===1">未确认</div>
            <div class="detail-cont" v-if="item.workloadStatusNew===2">拒绝确认</div>
            <div class="detail-cont" v-if="item.workloadStatusNew===3">待结算</div>
            <div class="detail-cont" v-if="item.workloadStatusNew===4">已关闭</div>
            <div class="detail-cont" v-if="item.workloadStatusNew===5">已结算</div>
            <div class="detail-cont" v-if="item.workloadStatusNew===6">不可结算</div>
            <div class="detail-cont" v-if="item.workloadStatusNew===7">待打款</div>
            <div v-if="item.salaryQuantity">服务数量：{{item.salaryQuantity}}</div> 
            <div v-else></div> 
          </div> 
        </div>
      </van-tab>
      <van-tab title="已失效" name="3">
        <div class="gongdan" v-if="orderList.length===0">
          <img :src="gongdan" alt="">
        </div>
        <div class="tab-detail" v-for="item in orderList" :key="item.id" @click="toDetailPage(item)">
          <div class="detail-left">
            <div class="basic-title">{{item.platformDetailDTO.taskName}}</div>
            <div class="date-time"><span>{{item.createdAt}} -- </span><span>{{item.endTime}}</span></div>
            <div class="message">
              <div class="posi"><img :src="duigou" alt=""></div>
              <div>{{item.userName}}</div>
              <div class="posi" style="margin-left:16px"><img :src="bohui" alt=""></div>
              <div>{{item.companyName}}</div>
            </div>
          </div>
          <div class="detail-right">
            <div class="detail-cont" v-if="item.workloadStatusNew===1">未确认</div>
            <div class="detail-cont" v-if="item.workloadStatusNew===2">拒绝确认</div>
            <div class="detail-cont" v-if="item.workloadStatusNew===3">待结算</div>
            <div class="detail-cont" v-if="item.workloadStatusNew===4">已关闭</div>
            <div class="detail-cont" v-if="item.workloadStatusNew===5">已结算</div>
            <div class="detail-cont" v-if="item.workloadStatusNew===6">不可结算</div>
            <div class="detail-cont" v-if="item.workloadStatusNew===7">待打款</div>
            <div v-if="item.salaryQuantity">服务数量：{{item.salaryQuantity}}</div> 
            <div v-else></div>  
          </div>     
        </div>
      </van-tab>
    </van-tabs>
    <!-- 分页 -->
    <div class="footer" v-if="orderList.length!==0">
      <van-pagination v-model="formData.currentPage" :total-items="pageCount" mode="simple" @change="ontabChange" />
    </div>
  </div>
</div>  
</template>
<script>
import http from "../../../api/index.js";
import config from "../../../utils/config";
export default {
  data(){
    return{
      formData:{
        currentPage:1,
        pageSize:10,
        workloadStatus:1,
      },
      pageCount:0,
      orderList:[],
      daiqueren:require("../../../assets/img/daiqueren.png"),
      duigou:require("../../../assets/img/duigou.png"),
      bohui:require("../../../assets/img/bohui.png"),
      gongdan:require("../../../assets/img/gongdan.png")
    }
  },
  mounted(){
    const url = new URL(location.href);
    url.searchParams.get('tabId') ?this.formData.workloadStatus = url.searchParams.get('tabId') :this.formData.workloadStatus;
    url.searchParams.get('currentPage') ?this.formData.currentPage = url.searchParams.get('currentPage') :this.formData.currentPage;
    this.myWorkloads()
  },
  methods:{
    myWorkloads(){
      http.post(config.myWorkloads,this.formData).then(({code,data,message})=>{
        if(code===0){
          this.orderList=data.rows;
          this.pageCount=data.count;
        }else{
          this.$toast.fail(message)
        }
      })
    },
    goBack(){
      this.$router.go(-1)

    },
    changeTab(){
      this.myWorkloads()
    },
    toDetailPage(item){
      this.$router.push({path:"/workOrderDetail",query:{id:item.id,tabId:this.formData.workloadStatus,currentPage:this.formData.currentPage}})
    },
    ontabChange(){
      this.myWorkloads()
    }
  }
}
</script>
<style lang="less" scoped>
.workOrder{
  height: 100%;
  background: #f9fafb;
  .order-top{
    display: flex;
    justify-content: space-between;
    padding: 20px;
    font-size: 35px;
    .jian{
      font-size: 35px;
    }

  }
  .order-tab{
    .gongdan{
      width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 60px;
    padding-top:150px;
    img{
      width: 50%;
      height: auto;
    }
    }
    .tab-detail{
      display: flex;
      justify-content: space-between;
      padding: 30px;
      background: #ffffff;
      margin-top: 20px;
      .detail-left{
        text-align: left;
        .basic-title{
          font-size: 30px;

        }
        .date-time{
          color: #777777;
          margin: 10px 0;
        }
        .message{
          display: flex;
          color: #777777;
          display: flex;
          .posi{
            position: relative;
            margin-right: 32px;
            img{
            width: 26px;
            height: auto;
            position: absolute;
            top:4px;
            left: 1px;
          }
          }
        }
      }
      .detail-right{
        color: #777777;
        text-align: right;
        .detail-cont{
          color: red;
          margin-bottom: 15px;
        }
      }

    }
    .footer{
    position: fixed;
    bottom: 0;
    width: 100%;
    background: #ffffff;
  }

  }
}

</style>


// WEBPACK FOOTER //
// src/pages/workOrder/workOrderTab/index.vue